import { PRILSource } from "@/constants/request/PRILConstants";
import FileMetaDTO from "@/dto/files/FileMetaDTO";
import {Direction} from "@/dto/request/pril/PRIL_DTO";

export default class AddPRILPayload {
  document: FileMetaDTO | null = null;
  customerId: number | null = null;
  sender: number | null = null;
  source: PRILSource | null = null;
  letterDate: Date | null = null;
  letterType: number | null = null;
  direction: Direction | null = null;
}
